export const actionTypes = {
  SET_HORIZON: "SET_HORIZON",
  SET_HORIZON_FILTERED: "SET_HORIZON_FILTERED",
  SET_LOADING: "SET_LOADING",
};
